var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{staticClass:"image-block",attrs:{"width":"sm"}},[_c('div',{staticClass:"image-block-img"},[_c('PrismicImage',{staticClass:"br-5",attrs:{"img":_vm.slice.primary.image1}})],1),_vm._v(" "),_c('div',{staticClass:"image-block-text rich-text",domProps:{"innerHTML":_vm._s(_vm.$prismic.asHtml(_vm.slice.primary.text))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }